import { useContext } from 'react';

import { FormContext, FormDispatchContext } from './context';

// Primary hook to use with the context
export function useForm() {
  const dispatch = useContext(FormDispatchContext);
  const state = useContext(FormContext);
  return { state, dispatch };
}
